import { MemberStateVm } from "./MemberStateVm";

export class CheckIssuedCardsVm {
  MemberStates: [MemberStateVm] = [new MemberStateVm()];
}
